import * as React from 'react';

import {SelectPickerGeneric} from 'shells/select-picker-generic/select-picker-generic';

import type {RoleFragment} from 'nutshell-graphql-types';

type Props = {
    selectedRoleId?: string | null | undefined;
    onSelectRole: (roleId: string) => void;
    roles: RoleFragment[];
};

export function RolePicker(props: Props) {
    const roleOptions = props.roles.map((opt) => ({value: opt.id, label: opt.name}));

    return (
        <SelectPickerGeneric
            minHeight={34}
            placeholder='Search roles…'
            openMenuOnFocus={true}
            options={roleOptions}
            value={
                props.selectedRoleId
                    ? roleOptions.find((option) => option.value === props.selectedRoleId)
                    : undefined
            }
            // @ts-expect-error
            onChange={(option) => {
                if (option && !Array.isArray(option)) {
                    props.onSelectRole(option.value);
                }
            }}
        />
    );
}
